import React, { forwardRef } from 'react';
import MenuItem from '@mui/material/MenuItem';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/display-name
const UiMenuItem = forwardRef((props, ref) => {
  const { children, className, ...restProps } = props;
  return (
    <MenuItem
      ref={ref}
      className={classNames('ui-menu-item', className)}
      {...restProps}
    >
      {children}
    </MenuItem>
  );
});

UiMenuItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default UiMenuItem;
